import * as React from "react";

import { sanitizeForUi } from "@/shared/lib/sanitize-unicode";
import { cn } from "@/shared/lib/utils";

type InputProps = React.ComponentProps<"input"> & {
  disableUnicodeSanitize?: boolean;
};

function Input({
  className,
  type,
  disableUnicodeSanitize,
  onChange,
  id,
  ...props
}: InputProps) {
  // KAN-301: у поля всегда есть id — иначе a11y-аудит «field should have an id
  // or name» и Label не с чем связывать
  const generatedId = React.useId();
  return (
    <input
      type={type}
      id={id ?? generatedId}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        className,
      )}
      onChange={(e) => {
        if (!disableUnicodeSanitize && typeof e.target.value === "string") {
          const sanitized = sanitizeForUi(e.target.value);
          if (sanitized !== e.target.value) {
            e.target.value = sanitized;
          }
        }
        onChange?.(e);
      }}
      {...props}
    />
  );
}

export { Input };
